import React, {Component, useState} from 'react';
import {useDispatch} from "react-redux";
import {Link, useHistory} from "react-router-dom";
import {deleteProduct} from "../../../stores/product/thunks";
import ModalAlerterCallback from "../../utils/ModalAlerterCallback";
import TableCell from "@mui/material/TableCell";
import {TableSortLabel} from "@mui/material";
import TableRow from "@mui/material/TableRow";
import separate from "../../functions/separate/separate";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Grid from "@mui/material/Grid";
import {ContainerHeader, SortableTableMat} from "../../module";
import Paper from "@mui/material/Paper";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import {makeStyles} from "@mui/styles";

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: 'row',
        alignItems: 'center',
        padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
        marginBottom: theme.spacing(2),
    },
    table: {
        minWidth: 750,
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },
    actions: {
        display: 'flex !important',
        flexDirection: 'row',
        gap: '0 10px'
    },
    editIcon: {
        color: '#FF8C00',
    },
    deleteIcon: {
        color: 'red',
    },
    viewEx: {
        color: '#0054a7',
    },
    item: {
        padding: '16px 8px',
    },
}));

const headCells = [
    {
        id: 'title',
        numeric: false,
        disablePadding: false,
        label: 'عنوان',
    },
    {
        id: 'type',
        numeric: false,
        disablePadding: false,
        label: 'نوع ویژگی',
    },
];

export default function Attributes() {

    const dispatch = useDispatch();
    const history = useHistory();

    function removeProductType(productType_id, refreshTable) {
        const callback = () =>
            dispatch(deleteProduct({productType_id}, refreshTable));
        ModalAlerterCallback(callback);
        // dispatch(deleteCoursesAdmin({ course_id }));
    }

    const ExerciseHeadMedel = (props) => {
        const classes = useStyles();
        const {headCell, order, orderBy} = props;

        return (
            <TableCell
                key={headCell.id}
                align={headCell.numeric ? 'right' : 'left'}
                padding={headCell.disablePadding ? 'none' : 'normal'}
                sortDirection={orderBy === headCell.id ? order : false}
            >
                <TableSortLabel
                    active={orderBy === headCell.id}
                    direction={orderBy === headCell.id ? order : 'asc'}
                    // onClick={createSortHandler(headCell.id)}
                >
                    {headCell.label}
                    {orderBy === headCell.id ? (
                        <span className={classes.visuallyHidden}>
            {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
          </span>
                    ) : null}
                </TableSortLabel>
            </TableCell>
        );
    };

    const ExerciseRowTableModel = (props) => {
        const classes = useStyles();
        const {row, onRemove, refreshTable} = props;

        function handleRemove() {
            onRemove(row.id, refreshTable);
        }

        return (
            <TableRow hover tabIndex={-1} key={row.id}>
                <TableCell align="left">{row.label}</TableCell>
                <TableCell align="left">{row.type.name}</TableCell>
            </TableRow>
        );
    };

    function addAttribute() {
        history.push('/attribute');
    }

    return (
        <Grid item xs={11} sm={12} className="d-flex flex-column DivParentCreateProduct">
            <ContainerHeader
                data={{
                    filter: false,
                    addBtn: true,
                }}
                headerTitle="لیست ویژگی ها"
                titleBtn="افزودن ویژگی"
                addBtnAction={addAttribute}
                // filterAction={(value) => {
                //     handleSearch(value);
                // }}
            />
            <SortableTableMat
                link={'attribute'}
                RowComponent={ExerciseRowTableModel}
                HeadCompnent={ExerciseHeadMedel}
                headers={headCells}
                keyData="attributes"
                // onRemove={removeProductType}
            />
        </Grid>
    );
}